import { jwtDecode } from "jwt-decode";
import JwtPayload from "./jwt-payload";

const decode = <T>(token: string): JwtPayload<T> | null => {
  const data = jwtDecode(token);

  if (!data) {
    return null;
  }

  return jwtDecode(token) as JwtPayload<T> | null;
};

const jwtService = {
  decode,
};

export default jwtService;
